

const initCap = (value) => {
    return (value + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
        return $1.toUpperCase();
    });
}

const capitalize = (value) => {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1)
}

const numberFormat = (value) => {
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const humanNumber = (num) => {
    if (num === null) { return null; } // terminate early
    if (num === 0) { return '0'; } // terminate early

    if((typeof(num)) == "string")
    {
        if(num.toLowerCase() == "n/a")
        {
            return num;
        }
        num = parseInt(num)
    }

    if(num == NaN)
    {
        return '';
    }

    let fixed = (!fixed || fixed < 0) ? 0 : 3; // number of decimal places to show
    let b = (num).toPrecision(2).split("e"), // get power
        k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3) ).toFixed(1 + fixed), // divide by power
        d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
        e = d + ['', 'K', 'M', 'B', 'T'][k]; // append power
    return e;
}

const strLimit = (value) => {
    if (!value) return '';
    value = value.toString();

    if (value.length <= size) {
        return value;
    }
    return value.substr(0, size) + '...';
}



const keywordRatingTitle = (value) => {
    if (value < 1000){
        return "Low Trend";
    }
    else if (value >1000 && value < 10000)
    {
        return  "Medium Trend";
    }
    return "High Trend";
}



const keywordCompetitionTitle = (value) => {

    if (!value) {
        return "N/A"
    }

    if (value > 0.01 && value <= 0.1) {
        return "Very Low";
    } else if (value > 0.11 && value <= 0.3) {
        return "Very Low";
    } else if (value > 0.31 && value <= 0.6) {
        return "Very Low";
    } else if (value > 0.61 && value <= 1) {
        return "Very Low";
    }

    return value;
}


const dateFormat = (date , format = "Y-MM-D") => {
    if (date == "" || date == null)
    {
        return "";
    }

    return  moment(date).format(format);

};

const diffForHumans = (date) => {
    return  moment(date).fromNow();
}



export default {
    initCap,
    capitalize,
    numberFormat,
    humanNumber,
    strLimit,
    keywordCompetitionTitle,
    keywordRatingTitle,
    dateFormat,
    diffForHumans

}

